import { useMemo } from "react";
import styles from "./skeleton.module.less";

export default function MasonrySkeleton({ columnNum }) {
  const cols = useMemo(() => {
    // 预设的随机高度
    const heights = [
      [242, 329, 278, 355],
      [329, 278, 355, 242],
      [400, 242, 329, 278],
      [278, 242, 329, 355],
      [200, 355, 278, 329],
    ];

    return Array.from({ length: columnNum }).map((_, i) => {
      return Array.from({ length: 4 }).map((_, ii) => {
        return (
          <div
            key={i + "-" + ii}
            className={`${styles.skeletonItem} ${
              i % 2 ? styles.staggered : ""
            }`}
          >
            <div
              className={styles.imageplaceholder}
              style={{ height: heights[i % 5][ii] }}
            />
            <div className={styles.textplaceholder} />
            {/* <div className={`${styles.textplaceholder} ${styles.short}`} /> */}
          </div>
        );
      });
    });
  }, [columnNum]);

  return (
    <div className={styles.masonryGrid}>
      {cols.map((colArr, index) => {
        return (
          <div className={styles.col} key={index}>
            {colArr}
          </div>
        );
      })}
    </div>
  );
}
